import React from 'react';
import BaseForm from "../forms/BaseForm";
import Input from "../forms/Input";


export default class SearchAndSelectModal extends React.Component {f

    constructor(props) {
        super(props);

        this.state = {
            hasSearched: 0,
            searchVal: ''
        }

    }


    componentDidMount() {
        if (this.props.defaultSearch) {
            this.setState({searchVal: this.props.defaultSearch}, this.handleSearchSubmit)
        }
    }

    handleSearchSubmit = (e) => {
        if (e) e.preventDefault();
        this.props.handleSearch(this.state.searchVal);
        this.setState({hasSearched: 1})
    }

    handleSearchAgain = () => {
        this.setState({searchVal: '', hasSearched: 0});
        this.props.handleSearch('');
    }

    render() {
        return (
            <div className={`modal ${this.props.visible ? 'is-active' : ''}`}>
                <div className="modal-background"/>
                <div className="modal-card">
                    <header className="modal-card-head has-background-success">
                        <h5 className="title is-5 has-text-white-bis">{this.props.title}</h5>
                    </header>
                    <section className="modal-card-body">
                        <form onSubmit={this.handleSearchSubmit}>
                            <Input
                                type="text"
                                value={this.state.searchVal}
                                controlClasses="full-width"
                                placeholder="Search"
                                disabled={this.props.disableSearch}
                                onChange={val => {
                                    this.setState({searchVal: val});
                                    // automatically clear the results if we have searched and then deleted the text
                                    if (!(val || val.length) && this.state.hasSearched) {
                                        this.props.handleSearch('');
                                        this.setState({hasSearched: 0});
                                    }
                                    
                                }}
                                addOns={[
                                    <div className="control">
                                        <button type="submit" className="button is-info">
                                            Search
                                        </button>
                                    </div>
                                ]}
                            />
                        </form>

                        <div className="ss-results mt-2">
                            {this.props.results.length ?
                                this.props.results.map(d => this.props.renderResultElement(d))
                                : <p className="mt-2">No results.</p>
                            }
                        </div>

                    </section>
                    <section className='modal-card-foot' style={{backgroundColor: 'white'}}>
                        <div className="buttons">
                            <button className="button is-info" onClick={this.props.onCancel}>Done</button>
                            <button className="button " onClick={this.handleSearchAgain}>Search Again</button>
                        </div>
                    </section>
                </div>
            </div>
        )
    }

}
